const { campos_novos: CamposNovos, prisms } = window.SIMBAR;

export const GROUP_NAME = CamposNovos.group;
export const SOURCE = CamposNovos.source;
export const PRISMS_Y_AXES = prisms.y_axes;
export const HOME_ROUTE_NAME = "campos_novos";
export const TITLE = "Campos Novos";
export const RTS_IMAGE = require("@/assets/images/campos_novos/rts_labeled.jpg");
export const SENSOR_UNITS = CamposNovos.sensor_units;
export const SENSOR_LABELS = CamposNovos.sensor_labels;
export const SPECIAL_PERMISSIONS = CamposNovos.special_permissions;
